<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    align-content-start
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >

        <material-card
        >
          <v-layout

            wrap>
            <v-flex
              xs12
              sm3
              md3>
              <v-text-field
                v-model="search"
                label="Search"
                single-line
                hide-details
                append-icon="search"
              />
            </v-flex>
          </v-layout>
          <br>
          <v-data-table
            :headers="byLinkedHeaders"
            :items="filteredAccounts"
            :search ="search"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"

          >
            <template
              slot="headerCell"
              slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text-md-left text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              v-slot:items="props">
              <td>
                <div
                  style="cursor:pointer; color:#ff9900;font-weight:400 "
                  @click="selectedAccount = true; selAcct = props.item.Acct_ID">
                  {{ props.item.Acct_ID }}
                </div>
              </td>
              <td>{{ props.item.Acct_name }}</td>
            </template>
          </v-data-table>
          <div
            v-if="selectedAccount === true"
            style=" margin-top:35px; padding:25px 0 ; border-top:1px solid gray">

            <!-- Account Status Filter

            <v-layout row wrap>
            <v-flex xs12 sm12 md2 xl2>
               <v-select v-model="selectedAcctStatus" :items="acctStatusFilter" chips label="Filter by Account Status" multiple solo></v-select>
            </v-flex>
            </v-layout> -->

            <v-data-table
              :headers="customerListHeaders"
              :items="accountSelected"
              :search ="search"
              :pagination.sync="pagination"
              hide-actions
              dark
              class="specificAccount"
            >
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text-md-left text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template
                v-slot:items="props">
                <td>
                  <Can
                    i="manage"
                    a="admin">
                    <v-icon
                      small
                      class="mr-2"
                      color="primary"
                      flat
                      @click="editItem(props.item)">edit</v-icon>
                    <v-icon
                      small
                      title="Changelogs"
                      class="mr-2"
                      color="primary"
                      flat
                      @click="onShowLogs(props.item)">history</v-icon>
                  <!-- <v-icon small class="mr-2" color="primary" @click="flagAccount(props.item.Acct_ID)" flat>delete</v-icon> -->
                  </Can>
                </td>
                <td>{{ props.item.OppReg_Id }}</td>
                <td>{{ props.item.ACE_Opportunity_Number }}</td>
                <td>{{ props.item.Acct_name }}</td>
                <td>{{ props.item.Acct_Status }}</td>
                <td>{{ props.item.Acct_DL }}</td>
                <td>{{ props.item.Acct_ID }}</td>
                <td>{{ props.item.Date_onboarded }}</td>
                <td>{{ props.item.Last_Date_Validated }}</td>
                <td>{{ props.item.Date_Suspended }}</td>
                <td>{{ props.item.MP_ID }}</td>
                <td>{{ props.item.Previous_MP_ID }}</td>
                <td>{{ props.item.Customer_Name }}</td>
                <td>{{ props.item.Managed_Svc }}</td>
                <td>{{ props.item.AWS_Support_Type }}</td>
                <td>{{ props.item.Customer_Region }}</td>
                <td>{{ props.item.Acct_Restricted }}</td>
                <td>{{ props.item.MFA }}</td>
                <td>{{ props.item.Root_Credential_Store }}
                </td><td>{{ props.item.DXC_discount }}</td>
                <td>{{ props.item.Client_discount }}</td>
                <td>{{ props.item.MP_uplift }}</td>
                <td>{{ props.item.Client_uplift }}</td>
                <td>{{ props.item.WBS_code }}</td>
                <td>{{ props.item.IWO_Code }}</td>
                <td>{{ props.item.Comments }}</td>
              </template>
            </v-data-table>
          </div>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  data: () => ({
    loader: null,
    isDownloading: false,
    downloadSuccess: false,
    selectedAcctStatus: false,
    search: '',
    selectedAccount: false,
    selAcct: '',
    acctSelected: [],
    editedIndex: -1,
    editedItem: {},
    dialog: false,
    rowsPerPageItems: [10, 20, 30, 40],
    pagination: {
      rowsPerPage: 10
    },

    dialog: false,
    onHide: false
  }),
  computed: {
    ...mapState('admin/accountInventory', ['masterAccounts', 'byLinkedHeaders', 'customerListHeaders', 'customersList', 'acctStatusFilter']),
    filteredAccounts () {
      console.log('--- Customer List ---')
      console.log(this.customersList)
      console.log('---------------------')
      return this.masterAccounts
    },
    accountSelected () {
      let i = this.masterAccounts.filter(res => {
        return res.Acct_ID == this.selAcct
      })

      console.log('---- accountSelected ------')
      console.log(i)
      return i
    },
    linkedAccountHeaders () {
      return this.customerListHeaders.filter(header => {
        return header.value == 'Acct_ID' || header.value == 'Acct_name'
      })
    }
  },
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]
      setTimeout(() => {
        this[l] = false
        this.downloadSuccess = true
      }, 3000)
      this.loader = null
    },
    filteredAccounts () {
      this.pagination.totalItems = this.filteredAccounts.length
    }
  },
  methods: {
    editItem (item) {
      this.$store.commit('admin/openAccountDialog', {
        show: true,
        type: 'edit',
        showSelectCustomer: false,
        fields: { ...item },
        accountIdExist: true,
        mpIdExist: true,
        submitLabel: 'Update',
        submitHandler: () => {
          this.$store.dispatch('admin/updateAccount')
        }
      })
      this.$store.commit('setChangeLogRecord', { id: item.Acct_ID, changeFrom: { ...item } }, { root: true })
    },
    save () {
      if (this.editedIndex > -1) {
        this.$store.dispatch('admin/accountInventory/updateCustomer', this.editedItem)
      } else {
        this.aws_customer.push(this.editedItem)
      }
      this.close()
    },
    onShowLogs (account) {
      this.$store.dispatch('showLogRecords', account.Acct_ID)
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    }
  }
}
</script>
<style lang="scss">

  table.theme--dark th + th { border-left:1px solid gray; padding:0 20px; }
  table.theme--dark td + td { border-left:1px solid gray; padding:0 20px; color:#000 }

table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-chipxld),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 10px;
}

table.v-table thead th:first-child {
  font-size: 10px;
  // font-weight: 600

}
.v-btn .v-btn__content {
  color: rgba(0, 0, 0, 0.87) !important;
  background-color: none;
  box-shadow: none;
  font-weight: 500;
}
#data-link {
  background-color: none;
  box-shadow: none;
  padding: 0;
  font-weight: 600;
}
.masterDropdown{
  margin-bottom:0 ;
.theme--light.v-text-field--solo>.v-input__control>.v-input__slot{
  background: linear-gradient(60deg, #ffa726, #fb8c00) !important;
  color:#fff !important;
}
.theme--light.v-select .v-select__selections{
  color:#fff !important;
}
  .theme--light.v-icon{
    color:#fff;
  }
}

</style>
